import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { StyledContent } from './styles';
import HeaderLayout from './HeaderLayout';
import { bindActionCreators } from 'redux';
import { ConfigProvider, Layout, theme } from 'antd';

import HomePageRouter from '../../../../routes/homePageRoute';
import LayoutAction from '../../../../modules/actions/LayoutAction';
import ThirdLevelComponent from './ThirdLevelMenu/ThirdLevelComponent';
import FooterLayout from './FooterLayout/index';
import '../../../../styles.css';

const { darkAlgorithm, defaultAlgorithm, lightAlgorithm,compactAlgorithm } = theme;
const { Content } = Layout;

const HomePageComponent = (props) => {
  const {
    layoutAction,
    location,
    selectedMenu,
    themeValue,
    userProfile = {}
  } = props;

  const [state, setState] = useState({
    hideLayout: false,
    hideFooter: false,
    ability: undefined,
    userProfile,
    selectedMenu: [],
    hideThirdLevelComponent: false,
    collapsed: false
  });

  useEffect(() => {
    layoutAction.getLoggedInProfile();
    _setCentralDashboard();
  }, []);
  useEffect(() => {
    if (selectedMenu.length >= 3) {
      setState(prevState => ({
        ...prevState,
        hideThirdLevelComponent: true
      }));
    }
  }, [selectedMenu]);

  const _setCentralDashboard = () => {
    const pathName = JSON.stringify(location.pathname);
    const hideThirdLevelComponent = !(
      pathName.match('editpanel') !== null ||
      pathName.match('/rubus/settingsPage') !== null
    );

    setState(prevState => ({
      ...prevState,
      hideThirdLevelComponent
    }));
  };

  const requestFullscreen = (element) => {
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullScreen) {
      element.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
    }
  };

  const hideLayout = (hideLayout) => {
    setState(prevState => ({
      ...prevState,
      hideLayout
    }));
  };

  const hideFooter = (hideFooter) => {
    setState(prevState => ({
      ...prevState,
      hideFooter
    }));
  };

  const { hideFooter: isHideFooter, hideThirdLevelComponent } = state;

  return (
    <div>
      <ConfigProvider
        theme={{
          token: themeValue.token,
          components: themeValue.components,
          algorithm: 
          themeValue.algorithm === "dark" ? [darkAlgorithm, compactAlgorithm] :
            themeValue.algorithm === "light" ? lightAlgorithm : defaultAlgorithm,
        }}
      >
        <Layout style={{ minHeight: '100vh' }}>
          <HeaderLayout
            collapsed={state.collapsed}
            hideLayout={state.hideLayout}
            fullScreen={requestFullscreen}
            history={props}
            menuHierarchy={true}
            {...props}
          />
          <Layout>
            {selectedMenu[0] !== 'ApplicationSettings' && hideThirdLevelComponent && selectedMenu.length >= 3 && (
              <div
                style={{
                  position: 'fixed',
                  zIndex: '1',
                  display: 'block',
                  width: '100%',
                  height: '16px'
                }}
              >
                <ThirdLevelComponent selectedMenu={selectedMenu} />
              </div>
            )}
            <StyledContent
              $marginval={hideThirdLevelComponent && selectedMenu.length >= 3 ? '115px' : '67px'}
            >
              <Content>
                <HomePageRouter
                  hideLayout={hideLayout}
                  hideFooter={hideFooter}
                  selectedMenu={selectedMenu}
                  sideMenu={true}
                />
              </Content>
            </StyledContent>
            {!isHideFooter ? <FooterLayout /> : <div />}
          </Layout>
        </Layout>
      </ConfigProvider>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  layoutAction: bindActionCreators(LayoutAction, dispatch)
});

const mapStateToProps = (state) => ({
  themeValue: state.ThemeReducer,
  selectedMenu: state.LayoutReducer.menuSelected,
  userProfile: state.LayoutReducer.getUserProfile
});

export default connect(mapStateToProps, mapDispatchToProps)(HomePageComponent);
